module.exports = __webpack_public_path__ + "img/profile-bg.58f22957.png";